module.exports = __webpack_public_path__ + "img/popup_button_normal_ok.e3ff9df8.png";